export const appVersion = __APP_VERSION__;
export const buildGitSha = __GIT_SHA__;
export const buildTime = __BUILD_TIME__;
export const appVersionLabel = buildGitSha ? `${appVersion}+${buildGitSha}` : appVersion;
